import ResponseStatus from '../constants/ResponseStatus';
import getCsrfTokenHeaders from './getCsrfTokenHeaders';

export function serializeFormData(data) {
    return Object.entries(data)
        .filter(([key, value]) => {
            const keyIsNotSet = key === undefined || key === null;
            const valueIsNotSet = value === undefined || value === null;
            return !keyIsNotSet && !valueIsNotSet;
        })
        .map(([key, value]) => {
            return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        })
        .join(`&`);
}

/**
 * @param {string} url
 * @param {object} params
 * @return {Promise<any|{responseStatus: string}>}
 */
export async function get(url, params = {}) {
    const requestBody = serializeFormData(params);
    const urlWithParams = requestBody ? `${url}?${requestBody}` : url;

    try {
        const response = await fetch(urlWithParams, {
            headers: {
                ...getCsrfTokenHeaders(),
            },
        });
        return await response.json();
    } catch {
        return { responseStatus: ResponseStatus.UI_NETWORK_ERROR };
    }
}

/**
 * @param {string} url
 * @param {object} params
 * @return {Promise<any|{responseStatus: string}>}
 */
export async function post(url, params = {}) {
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                ...getCsrfTokenHeaders(),
            },
            body: serializeFormData(params),
        });
        return await response.json();
    } catch {
        return { responseStatus: ResponseStatus.UI_NETWORK_ERROR };
    }
}

/**
 * @param {string} url
 * @param {object} params
 * @return {Promise<any|{responseStatus: string}>}
 */
export async function remove(url, params) {
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                ...getCsrfTokenHeaders(),
            },
            body: serializeFormData(params),
        });
        return await response.json();
    } catch {
        return { responseStatus: ResponseStatus.UI_NETWORK_ERROR };
    }
}
